import type { NodePropertyName } from '@salescore/core'
import { Form, Row } from 'antd'
import { t } from 'i18next'
import type { ReactElement } from 'react'

import { useCurrentNodeDateProperties } from '../../../../recoil/view/selectors/kpiFormSelector'
import { PropertySelect } from './PropertySelect'

export const KpiFormDateFormItem = ({
  date,
  setDate,
}: {
  date: { property: NodePropertyName } | undefined
  setDate: (date: { property: NodePropertyName } | undefined) => void
}): ReactElement => {
  const currentNodeDateProperties = useCurrentNodeDateProperties()

  return (
    <Row>
      <Form.Item label={t(`期間項目`)} style={{ width: `100%` }}>
        <PropertySelect
          allowClear
          properties={currentNodeDateProperties}
          value={date?.property}
          onChange={(nodePropertyName) => {
            setDate(nodePropertyName === undefined ? undefined : { property: nodePropertyName })
          }}
        />
      </Form.Item>
    </Row>
  )
}
